import { format as formatDateFns } from 'date-fns';

export const formatDate = (dateString) => {
  try {
    return new Date(dateString).toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric', 
      year: 'numeric', 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  } catch {
    return dateString;
  }
};

export const formatDateShort = (dateString) => {
  try {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  } catch {
    return dateString;
  }
};

export const formatDateForApi = (date) => {
  return formatDateFns(date, 'yyyy-MM-dd');
};

export const formatDatePretty = (date) => {
  return formatDateFns(date, 'PPP');
};

export const getRiskBadgeClass = (risk) => {
  const map = {
    'high_risk': 'risk-high',
    'medium_risk': 'risk-medium', 
    'acceptable': 'risk-acceptable',
    'good': 'risk-good',
    'Critical': 'bg-red-100 text-red-700',
    'Medium': 'bg-yellow-100 text-yellow-700'
  };
  return map[risk] || 'bg-slate-100 text-slate-600';
};

export const getRiskLabel = (risk) => {
  const map = {
    'high_risk': 'High Risk',
    'medium_risk': 'Medium Risk',
    'acceptable': 'Acceptable',
    'good': 'Good'
  };
  return map[risk] || risk;
};
